// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { closeGlobalPopup } from "../../redux/action";
// import { mapCategoryAddonsAPI } from "../../redux/api";

// function MapCategoryAddonForm({ category }) {
//   const dispatch = useDispatch();
//   const allAddonGroups = useSelector((state) => state.admin?.addonGroups) || [];
  
//   // Array of selected AddonGroupIds
//   const [selectedGroupIds, setSelectedGroupIds] = useState([]);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     // Agar category ke sath pre-mapped IDs hain toh initialize karein
//     if (category?.addonGroupIds) {
//       setSelectedGroupIds(category.addonGroupIds);
//     }
//   }, [category]);

//   const handleToggle = (groupId) => {
//     setSelectedGroupIds((prev) =>
//       prev.includes(groupId)
//         ? prev.filter((id) => id !== groupId)
//         : [...prev, groupId]
//     );
//   };

//   const handleSave = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       const payload = {
//         categoryId: category.categoryId,
//         addonGroupIds: selectedGroupIds,
//       };

//       await mapCategoryAddonsAPI("MapCategoryAddons", payload);
//       dispatch({ type: "FETCH_CATEGORY_LIST" }); // Refresh list to reflect updates
//       dispatch(closeGlobalPopup());
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <form onSubmit={handleSave} style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
//       <p style={{ margin: 0, fontSize: "14px", color: "#4b5563" }}>
//         Select the Add-on groups that will automatically apply to all items in{" "}
//         <strong>{category?.categoryName}</strong>:
//       </p>

//       {allAddonGroups.length === 0 ? (
//         <p style={{ color: "#9ca3af", textAlign: "center", margin: "20px 0" }}>
//           No Add-on Groups found. Create some in "Manage Add On" first.
//         </p>
//       ) : (
//         <div style={listContainerStyle}>
//           {allAddonGroups.map((group) => {
//             const isChecked = selectedGroupIds.includes(group.addonGroupId);
//             return (
//               <label key={group.addonGroupId} style={itemRowStyle(isChecked)}>
//                 <input
//                   type="checkbox"
//                   checked={isChecked}
//                   onChange={() => handleToggle(group.addonGroupId)}
//                   style={{ width: "18px", height: "18px", cursor: "pointer" }}
//                 />
//                 <div style={{ flex: 1 }}>
//                   <div style={{ fontWeight: "600", fontSize: "14px" }}>
//                     {group.groupName}
//                   </div>
//                   <div style={{ fontSize: "12px", color: "#6b7280" }}>
//                     Max Allowed: {group.maxSelection} | Items: {group.addonItems?.length || 0}
//                   </div>
//                 </div>
//               </label>
//             );
//           })}
//         </div>
//       )}

//       <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
//         <button
//           type="submit"
//           disabled={loading}
//           style={{
//             flex: 1,
//             padding: "10px",
//             backgroundColor: "#16a34a",
//             color: "white",
//             border: "none",
//             borderRadius: "6px",
//             fontWeight: "bold",
//             cursor: "pointer",
//           }}
//         >
//           {loading ? "Saving..." : "Save Mappings"}
//         </button>
//         <button
//           type="button"
//           onClick={() => dispatch(closeGlobalPopup())}
//           style={{
//             flex: 1,
//             padding: "10px",
//             backgroundColor: "#dc2626",
//             color: "white",
//             border: "none",
//             borderRadius: "6px",
//             fontWeight: "bold",
//             cursor: "pointer",
//           }}
//         >
//           Cancel
//         </button>
//       </div>
//     </form>
//   );
// }

// const listContainerStyle = {
//   maxHeight: "260px",
//   overflowY: "auto",
//   display: "flex",
//   flexDirection: "column",
//   gap: "8px",
//   border: "1px solid #e5e7eb",
//   borderRadius: "8px",
//   padding: "8px",
// };

// const itemRowStyle = (isChecked) => ({
//   display: "flex",
//   alignItems: "center",
//   gap: "12px",
//   padding: "10px",
//   borderRadius: "6px",
//   backgroundColor: isChecked ? "#f0fdf4" : "#ffffff",
//   border: `1px solid ${isChecked ? "#86efac" : "#e5e7eb"}`,
//   cursor: "pointer",
// });

// export default MapCategoryAddonForm;



import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeGlobalPopup } from "../../redux/action";
import { mapCategoryAddonsAPI, getCategoryAddonMappingsAPI } from "../../redux/api";
import { ButtonLoader, SectionLoader } from "../common/Loader";
import EmptyScreen from "../common/EmptyScreen";

function MapCategoryAddonForm({ category }) {
  const dispatch = useDispatch();
  const allAddonGroups = useSelector((state) => state.admin?.addonGroups) || [];

  const [selectedGroupIds, setSelectedGroupIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetchingMapped, setFetchingMapped] = useState(false);

  // ⭐ FIX: Modal open hone par category ke mapped IDs fetch karein
  useEffect(() => {
    if (category?.categoryId) {
      setFetchingMapped(true);
      getCategoryAddonMappingsAPI("GetCategoryAddons", category.categoryId)
        .then((data) => {
          // data array of GUIDs hona chahiye e.g. ["guid1", "guid2"]
          // agar objects array ho toh mapping karein
          const ids = Array.isArray(data)
            ? data.map((item) => (typeof item === "string" ? item : item.addonGroupId || item))
            : [];
          setSelectedGroupIds(ids);
        })
        .catch((err) => {
          console.error("Error fetching category addons:", err);
          setSelectedGroupIds([]);
        })
        .finally(() => {
          setFetchingMapped(false);
        });
    }
  }, [category]);

  const handleToggle = (groupId) => {
    setSelectedGroupIds((prev) =>
      prev.includes(groupId)
        ? prev.filter((id) => id !== groupId)
        : [...prev, groupId]
    );
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        categoryId: category.categoryId,
        addonGroupIds: selectedGroupIds,
      };

      await mapCategoryAddonsAPI("MapCategoryAddons", payload);
      dispatch({ type: "FETCH_CATEGORY_LIST" });
      dispatch(closeGlobalPopup());
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSave} style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <p style={{ margin: 0, fontSize: "14px", color: "var(--ui-muted)" }}>
        Select the Add-on groups that will automatically apply to all items in{" "}
        <strong>{category?.categoryName}</strong>:
      </p>

      {fetchingMapped ? (
        <SectionLoader label="Loading mapped add-ons..." rows={2} compact />
      ) : allAddonGroups.length === 0 ? (
        <EmptyScreen compact message="No add-on groups available." subText="Create a group in Manage Add On before mapping it to this category." />
      ) : (
        <div style={listContainerStyle}>
          {allAddonGroups.map((group) => {
            const isChecked = selectedGroupIds.includes(group.addonGroupId);
            return (
              <label key={group.addonGroupId} style={itemRowStyle(isChecked)}>
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={() => handleToggle(group.addonGroupId)}
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: "600", fontSize: "14px" }}>
                    {group.groupName}
                  </div>
                  <div style={{ fontSize: "12px", color: "var(--ui-muted)" }}>
                    Max Allowed: {group.maxSelection} | Items: {group.addonItems?.length || 0}
                  </div>
                </div>
              </label>
            );
          })}
        </div>
      )}

      <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
        <button
          type="submit"
          disabled={loading || fetchingMapped}
          style={{
            flex: 1,
            padding: "10px",
            backgroundColor: "var(--ui-success)",
            color: "var(--ui-on-primary)",
            border: "none",
            borderRadius: "6px",
            fontWeight: "bold",
            cursor: "pointer",
            opacity: loading ? 0.7 : 1,
          }}
        >
          {loading ? <ButtonLoader label="Saving mappings..." /> : "Save Mappings"}
        </button>
        <button
          type="button"
          onClick={() => dispatch(closeGlobalPopup())}
          style={{
            flex: 1,
            padding: "10px",
            backgroundColor: "#dc2626",
            color: "var(--ui-on-primary)",
            border: "none",
            borderRadius: "6px",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          Cancel
        </button>
      </div>
    </form>
  );
}

const listContainerStyle = {
  maxHeight: "260px",
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  border: "1px solid var(--ui-border)",
  borderRadius: "8px",
  padding: "8px",
};

const itemRowStyle = (isChecked) => ({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  padding: "10px",
  borderRadius: "6px",
  backgroundColor: isChecked ? "#f0fdf4" : "#ffffff",
  border: `1px solid ${isChecked ? "#86efac" : "#e5e7eb"}`,
  cursor: "pointer",
});

export default MapCategoryAddonForm;
